module.exports = __webpack_public_path__ + "static/media/whell-animation-store.6f256069.svg";